// Zenklub services.
import { HttpClient, HttpParams } from '@angular/common/http';
// Angular modules.
import { Injectable } from '@angular/core';
import { IEvent } from 'app/interfaces/event.interface';
import { ICompensationBonus } from 'app/interfaces/stats.interface';
import * as moment from 'moment-timezone';
import { Observable } from 'rxjs';

export interface ICompensationStats {
	day: string;
	totalCompensation: number;
}
export interface ICompensationStatsResponse {
	stats: ICompensationStats[];
	hadRevenueAllTime: boolean;
}
export interface IEventStats {
	items: IEvent[];
	total: number;
	totalRevenue: number;
}

export interface SearchStatsEvents {
	skip: number;
	limit: number;
	minDate: Date | null;
	maxDate: Date | null;
	profileId?: string;
	order?: string;
}

@Injectable()
export class StatsService {
	// Constructor.
	constructor(private http: HttpClient) {}

	public getCompensationStats(
		minDate: moment.Moment,
		maxDate: moment.Moment
	): Observable<ICompensationStatsResponse> {
		const url = `appointments/compensation/stats?minDate=${minDate.toISOString()}&maxDate=${maxDate.toISOString()}`;
		return this.http.get<ICompensationStatsResponse>(url);
	}

	public getAppointmentStats(
		search: SearchStatsEvents
	): Observable<IEventStats> {
		let params = new HttpParams();
		params = params.set('limit', search.limit.toString(10));
		params = params.set('skip', search.skip.toString(10));
		// set to always the start of the day
		params = params.set(
			'minDate',
			moment(search.minDate).startOf('day').utc().toISOString()
		);
		// set to always the end of the day
		params = params.set(
			'maxDate',
			moment(search.maxDate).endOf('day').utc().toISOString()
		);
		if (search.profileId) {
			params = params.set('profileId', search.profileId);
		}
		if (search.order) {
			params = params.set('order', search.order);
		}

		return this.http.get<IEventStats>('appointments/stats', { params });
	}

	public getFinanceReport(search: SearchStatsEvents): Observable<string> {
		let params = new HttpParams();
		// set to always the start of the day
		params = params.set(
			'minDate',
			moment(search.minDate).startOf('day').utc().toISOString()
		);
		// set to always the end of the day
		params = params.set(
			'maxDate',
			moment(search.maxDate).endOf('day').utc().toISOString()
		);
		// send local timezone
		params = params.set('timezone', encodeURIComponent(moment.tz.guess()));

		if (search.profileId) {
			params = params.set('profileId', search.profileId);
		}
		if (search.order) {
			params = params.set('order', search.order);
		}

		return this.http.get<string>('appointments/financeReport', { params });
	}

	public getCompensationBonus(): Observable<ICompensationBonus> {
		return this.http.get<ICompensationBonus>(
			'appointments/compensationbonus',
			{}
		);
	}
}
